/**
 * @generated SignedSource<<d774033415bc683b5d632426e22db4b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveWebHookSettingsInput = {
  clientMutationId: string;
  deliveryEndpoints?: ReadonlyArray<WebHookDeliveryEndpointInput> | null;
  ownerUid: string;
  platform: string;
};
export type WebHookDeliveryEndpointInput = {
  secretToken?: string | null;
  webhookURL: string;
};
export type WebHookSettingsCreateMutation$variables = {
  input: SaveWebHookSettingsInput;
};
export type WebHookSettingsCreateMutation$data = {
  readonly saveWebHookSettings: {
    readonly error: string | null;
    readonly info: {
      readonly " $fragmentSpreads": FragmentRefs<"WebHookSettings_info">;
    };
  };
};
export type WebHookSettingsCreateMutation = {
  response: WebHookSettingsCreateMutation$data;
  variables: WebHookSettingsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WebHookSettingsCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveWebHookSettingsPayload",
        "kind": "LinkedField",
        "name": "saveWebHookSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OwnerInfo",
            "kind": "LinkedField",
            "name": "info",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WebHookSettings_info"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WebHookSettingsCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveWebHookSettingsPayload",
        "kind": "LinkedField",
        "name": "saveWebHookSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OwnerInfo",
            "kind": "LinkedField",
            "name": "info",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "platform",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WebHookSettings",
                "kind": "LinkedField",
                "name": "webhookSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ownerUid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WebHookDeliveryEndpoint",
                    "kind": "LinkedField",
                    "name": "endpoints",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webhookURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maskedSecretToken",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "last",
                    "value": 50
                  }
                ],
                "concreteType": "OwnerWebhookDeliveriesConnection",
                "kind": "LinkedField",
                "name": "webhookDeliveries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OwnerWebHookDeliveryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebHookDelivery",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebHookDeliveryResponse",
                            "kind": "LinkedField",
                            "name": "response",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "webhookDeliveries(last:50)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "939641fc5b2a9e85737ca84bd2508557",
    "id": null,
    "metadata": {},
    "name": "WebHookSettingsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation WebHookSettingsCreateMutation(\n  $input: SaveWebHookSettingsInput!\n) {\n  saveWebHookSettings(input: $input) {\n    error\n    info {\n      ...WebHookSettings_info\n    }\n  }\n}\n\nfragment DeliveryRow_delivery on WebHookDelivery {\n  id\n  timestamp\n  response {\n    status\n  }\n}\n\nfragment WebHookSettings_info on OwnerInfo {\n  platform\n  uid\n  webhookSettings {\n    ownerUid\n    endpoints {\n      webhookURL\n      maskedSecretToken\n    }\n  }\n  webhookDeliveries(last: 50) {\n    edges {\n      node {\n        ...DeliveryRow_delivery\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "185aa172e4f8bea1c60196c2f077c10e";

export default node;
